import script from "./LinksField.vue?vue&type=script&setup=true&lang=js"
export * from "./LinksField.vue?vue&type=script&setup=true&lang=js"

import "./LinksField.vue?vue&type=style&index=0&id=b9581e3c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9581e3c"]])

export default __exports__